var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechnologyReadinessandAdoptionAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2414 12.5173H39.069V18.8621H42.2414V12.5173Z",
    fill: "#373D3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8638 15.7926L24.1199 17.3781L27.2942 22.8715L30.0381 21.2859L26.8638 15.7926Z",
    fill: "#373D3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6955 28.9533L19.1907 32.1251L20.775 29.3802L15.2798 26.2084L13.6955 28.9533Z",
    fill: "#373D3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6261 56.3588L15.2161 59.1076L20.7082 55.9307L19.1182 53.1819L13.6261 56.3588Z",
    fill: "#373D3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5045 28.9041L65.9215 26.1624L60.4269 29.3348L62.0099 32.0765L67.5045 28.9041Z",
    fill: "#373D3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1224 17.2873L54.3806 15.7043L51.2082 21.1989L53.95 22.7819L57.1224 17.2873Z",
    fill: "#373D3F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4138 55.3448C45.4138 53.2764 44.0846 51.5348 42.2414 50.8781V25.2069H39.069V50.8781C37.2258 51.5348 35.8966 53.2764 35.8966 55.3448C35.8966 57.9716 38.0284 60.1035 40.6552 60.1035C43.2819 60.1035 45.4138 57.9716 45.4138 55.3448Z",
    fill: "#373D3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8621 41.069H10.5172V44.2414H16.8621V41.069Z",
    fill: "#373D3F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7931 41.069H64.4483V44.2414H69.2069H70.7931V41.069Z",
    fill: "#373D3F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7241 69.6207H29.5517V72.7931H32.7241V69.6207Z",
    fill: "#373D3F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.069 69.6207H35.8966V72.7931H39.069V69.6207Z",
    fill: "#373D3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4138 69.6207H42.2414V72.7931H45.4138V69.6207Z",
    fill: "#373D3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0788 46.8872C80.2279 45.4977 80.3103 44.0859 80.3103 42.6552C80.3103 20.756 62.5543 3 40.6552 3C18.756 3 1 20.756 1 42.6552C1 64.5543 18.756 82.3104 40.6552 82.3104C43.6817 82.3104 46.6193 81.9392 49.4523 81.2984C53.7224 87.6495 60.9745 91.8276 69.2069 91.8276C82.3502 91.8276 93 81.1778 93 68.0345C93 58.8155 87.7465 50.8369 80.0788 46.8872ZM40.6552 79.1379C20.5389 79.1379 4.17241 62.7715 4.17241 42.6552C4.17241 22.5389 20.5389 6.17241 40.6552 6.17241C60.7714 6.17241 77.1379 22.5389 77.1379 42.6552C77.1379 43.6418 77.0681 44.6062 76.9888 45.5706C74.5461 44.7236 71.9352 44.2414 69.2069 44.2414C56.0636 44.2414 45.4138 54.8912 45.4138 68.0345C45.4138 71.7652 46.2958 75.2802 47.8249 78.4209C45.5058 78.8873 43.1074 79.1379 40.6552 79.1379ZM69.2069 88.6552C57.8179 88.6552 48.5862 79.4235 48.5862 68.0345C48.5862 56.6455 57.8179 47.4138 69.2069 47.4138C80.5959 47.4138 89.8276 56.6455 89.8276 68.0345C89.8276 79.4235 80.5959 88.6552 69.2069 88.6552Z",
    fill: "#373D3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7211 73.6433L57.9924 66.9114L55.7495 69.1575L64.7211 78.1291L82.6643 60.1827L80.4214 57.9398L64.7211 73.6433Z",
    fill: "#373D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologyReadinessandAdoptionAgent);
export default __webpack_public_path__ + "static/media/Technology Readiness and Adoption Agent.bb530f8239e78340fd34f0e08792576e.svg";
export { ForwardRef as ReactComponent };